import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {BarChart, ChartsLabelMark} from '@mui/x-charts';
import {XYVO} from "@/service/analyze";
import {formatMoney, transformMoney} from "@/helper/method";
import {useMemo} from "react";
import {sumBy} from "lodash";

const numberFormatter = Intl.NumberFormat('en-US', {
    useGrouping: true,
});
const numberWithSuffixFormatter = new Intl.NumberFormat('en-US', {
    notation: 'compact',
});

export interface SalesRankingProps {
    sellerYearRanking?: XYVO[]
    loading: boolean
}

const colors = ["#60B5FF", "#FCB454"]

export default function SalesRanking({sellerYearRanking, loading}: SalesRankingProps) {
    const totalMoney = useMemo(() => {
        if (sellerYearRanking) {
            const totalMoney = sumBy(sellerYearRanking, (sellerYear) => parseFloat(sellerYear?.y?.toString()));
            return transformMoney(totalMoney, 2)
        }
        return "0"
    }, [sellerYearRanking]);
    return (
        <Card variant="outlined" sx={{width: '100%'}}>
            <CardContent>
                <Stack direction={'row'} alignContent={'center'} alignItems={'center'} sx={{justifyContent: 'space-between'}}>
                    <Typography component="h2" variant="subtitle2" gutterBottom>
                        本年度销售业绩
                    </Typography>
                    <Typography variant="subtitle2" gutterBottom>总共{totalMoney}</Typography>
                </Stack>
                <BarChart
                    height={240}
                    hideLegend={true}
                    loading={loading}
                    localeText={{loading: "加载中"}}
                    series={[
                        {
                            data: sellerYearRanking?.map(item => (item.y)),
                            label: '金额',
                            color: '#60B5FF',
                            type: 'bar',
                            valueFormatter: (d: number | null) => transformMoney(d),
                        },
                    ]}
                    margin={{left: 0, right: 0, top: 20, bottom: 10}}
                    xAxis={[
                        {
                            data: sellerYearRanking?.map(item => item.x),
                            // disableLine: true,
                            disableTicks: true,
                            tickNumber: 2,
                            categoryGapRatio: 0.6,
                        },
                    ]}
                    yAxis={[
                        {
                            width: 48,
                            disableLine: true,
                            disableTicks: true,
                            valueFormatter: (d: number | null) => transformMoney(d),
                        },
                    ]}
                    layout="vertical"
                />
            </CardContent>
        </Card>
    );
}
